import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import React, { FC } from "react";
import { CandidateCourseViewModel } from "../../model/courses/CandidateCourseViewModel";
import TranslatedMessage from "../translations/TranslatedMessage";
import CandidateCourseTableRow from "./CandidateCourseTableRow";

type CandidateCourseTableProps = {
  candidateCourses: CandidateCourseViewModel[];
  handleDownloadCertificate: (candidateCourse: CandidateCourseViewModel) => Promise<void>;
  handleDownloadPerformanceRecord: (candidateCourse: CandidateCourseViewModel) => Promise<void>;
};

const tableHeaders = (
  <TableHead>
    <TableRow>
      <TableCell>
        <TranslatedMessage id="course.header" />
      </TableCell>
      <TableCell>
        <TranslatedMessage id="home.myCourses.table.ClosingDate" />
      </TableCell>
      <TableCell>
        <TranslatedMessage id="common.field.status" />
      </TableCell>
      <TableCell>
        <TranslatedMessage id="home.myCourses.table.downloads" />
      </TableCell>
    </TableRow>
  </TableHead>
);

const CandidateCourseTable: FC<CandidateCourseTableProps> = ({
  candidateCourses,
  handleDownloadCertificate,
  handleDownloadPerformanceRecord,
}) => {
  return (
    <TableContainer component={Paper} style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
      <Table size="small">
        {tableHeaders}
        <TableBody>
          {candidateCourses.map((course, courseIndex) => (
            <CandidateCourseTableRow
              key={courseIndex}
              candidateCourse={course}
              handleDownloadCertificate={handleDownloadCertificate}
              handleDownloadPerformanceRecord={handleDownloadPerformanceRecord}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default CandidateCourseTable;
